export const getParams = (query: string = '?') => {
    return query
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            if (key) {
                if (key.includes('columnGroup_')) {
                    const [groupKey, columnKey] = key.split('_');
                    const column = {};
                    column[columnKey] = value
                        ? decodeURIComponent(value)
                        : undefined;
                    params[groupKey] = { ...params[groupKey], ...column };
                } else {
                    params[key] = value ? decodeURIComponent(value) : undefined;
                }
            }
            return params;
        }, {});
};

export const getFilterParams = (query: string = '?') => {
    return query
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            if (key && key.startsWith('_')) {
                params[key.slice(1)] = value
                    ? decodeURIComponent(value)
                    : undefined;
            }
            return params;
        }, {});
};

export const getNonFilterParams = (query: string = '?') => {
    return query
        .slice(1)
        .split('&')
        .reduce((params, param) => {
            const [key, value] = param.split('=');
            if (key && !key.startsWith('_')) {
                params[key] = value ? decodeURIComponent(value) : undefined;
            }
            return params;
        }, {});
};



// WEBPACK FOOTER //
// ./src/utils/getParams.ts